// extracted by mini-css-extract-plugin
module.exports = {"hosts":"footer_hosts__Nls4k","partnerLogo":"footer_partnerLogo__JwOil","container":"footer_container__rOTjF","section":"footer_section__Eg_KD"};